<template>
	<c-dialog ref="dialog" width="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id" ></c-input>
			<c-form-item label="仓库编号" required>
				<c-input name="warehouse_code" ></c-input>
			</c-form-item>
			<c-form-item label="仓库名称" required>
				<c-input name="warehouse_name"></c-input>
			</c-form-item>
			<c-form-item label="仓库状态" required>
				<c-radio-group name="warehouse_state" :options="disableEnableDic" :disabled="this.editState && isDefault == 2"></c-radio-group>
			</c-form-item>
			<c-form-item label="仓库管理员" tip="管理员将接收当前仓库商品库存不足或者库存超限的通知消息">
				<c-select name="manager_user_ids" async @search="searchUser" :value-data="selectedUser" multiple required></c-select>
			</c-form-item>
			<c-form-item label="备注说明">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
	
export default {
	computed: {
		// 获取dictName选项数据
		...mapState(['disableEnableDic','systemConfig']),
	},
	
	data() {
		return {
			editState: false,
			isDefault: 2,
			selectedUser:[]
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		async open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			
			if (data) {
				this.isDefault = data.is_default;
				//已选中的用户
				if (data.manager_user_ids){
					this.request({
						url: 'sys_user/list/by/ids',
						data: {
							ids: data.manager_user_ids
						},
						success: data => {
							this.selectedUser = data.map(item => {
								return {
									name:item.user_realname,
									value:item.id
								}
							});
						}
					})
				}
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑仓库' : '创建仓库'
			});
		},

		/*******搜索用户*****************/
		searchUser(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SYSUSER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/warehouse/edit':'/warehouse/add',
				rule: {
					warehouse_code: '请输入仓库编号',
					warehouse_name: '请输入仓库名称',
					warehouse_state: '请选择状态'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>